import {BibFormaAquisicaoModel} from '@/models/biblioteca/bibformaaquisicao/bibformaaquisicao.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibFormaAquisicaoService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibFormaAquisicaoModel>>> {
  return api.post <DataSource <BibFormaAquisicaoModel>>('/BibFormaAquisicao/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibFormaAquisicao: BibFormaAquisicaoModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibFormaAquisicao', bibFormaAquisicao);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibFormaAquisicao/' + id);
 }

 atualizar(bibFormaAquisicao: BibFormaAquisicaoModel): Promise<AxiosResponse> {
  return api.put('/BibFormaAquisicao', bibFormaAquisicao);
 }

 async get(id: number): Promise<BibFormaAquisicaoModel> {
  const result = await api.get<BibFormaAquisicaoModel>(`/BibFormaAquisicao/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/BibFormaAquisicao/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new BibFormaAquisicaoService();
